import { Button } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import PropTypes from 'prop-types';
import { GLOBALPROPS } from '../../GlobalApp.jsx';
import { Link } from 'react-router-dom';
import { translate } from '../../../../../SharedLibs/Langs.js';
import { AccountStore } from '../../../flux/stores/AccountStore.js';
import { ConfigStore } from '../../../flux/stores/ConfigStore.js';
import { AccountServices } from '../../../services/AccountServices.js';
import { MessageServices } from '../../../services/MessageServices.js';
import GenericFormular from './GenericFormular.jsx';
import { ProgressStore } from '../../../flux/stores/ProgressStore.js';
import { LynError } from '../../../../../SharedLibs/LynError.js';
import { throws } from 'assert';


// ---- For debugging ------
// import { debugInit } from '../../../../../SharedLibs/Debug.js';
// var debug = debugInit("Account");


const styles = (theme) => ({
	layout: {
		width: 'auto',
		display: 'block', // Fix IE11 issue.
		marginLeft: theme.spacing.unit * 3,
		marginRight: theme.spacing.unit * 3,
		[theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
			width: 400,
			marginLeft: 'auto',
			marginRight: 'auto',
		},
	},
	paper: {
		marginTop: theme.spacing.unit * 8,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
	},
	avatar: {
		backgroundColor: 'transparent',
		width: 'unset',
		height: 'unset',
		borderRadius: 0
	},
	form: {
		width: '100%', // Fix IE11 issue.
		marginTop: theme.spacing.unit,
	},
	submit: {
		marginTop: theme.spacing.unit * 3,
	},
	footer: {
		paddingTop: 30
	},
	link: {
		textDecoration: 'none',
		color: 'inherit'
	},
	content: {
		padding: '15px 0px'
	}
});

class LoginForm extends GenericFormular {
	constructor(props) {
		super(props);

		this.title = translate("LOGIN TO YOUR ACCOUNT");

		this.state = {
			'login': props.email ? props.email : props.login ? props.login : undefined,
			'password': undefined,
			'_pathname': props._pathname ? props._pathname : ""
		};

		this.handleChange = this.handleChange.bind(this);

	}

	checkForValidity(d) {
		// ------- check for empty login -----
		this.setState({
			data: d,
			errorTextLogin: d.login ? undefined : translate("Must be filled"),
			submitDisabled: d.login ? false : true,
		});
		return true;
	}

	login() {

		AccountServices.login({ "login": this.state.login, "password": this.state.password })
			.then(() => {
				if (!AccountStore.logged) {
					return MessageServices.setInStore({ "error": new Error("There was an error from our server. Please contact us.") });
				}
			})
			.catch((err) => {
				MessageServices.setInStore({ "error": err });
			})
	}

	loginLdap(){
		AccountServices.loginLdap({ "login": this.state.login, "password": this.state.password })
			.then(() => {
				if (!AccountStore.logged) {
					AccountServices.stopProgress("main");
					return MessageServices.setInStore({ "error": new Error("There was an error from our server. Please contact us.") });
				}
			})
			.catch((err) => {
				MessageServices.setInStore({ "error": err });
			})
	}

	renderListOfAuths() {
		let arr = [];
		let localAuth = ConfigStore.localAuth;
		let googleAuth = ConfigStore.googleAuth;
		let ldapAuth = ConfigStore.ldapAuth;
		if (localAuth) arr.push(this.renderLocalAuth());
		if (ldapAuth) arr.push(this.renderLdapAuth());
		if ((localAuth) && (googleAuth)) arr.push(this.renderAuthSeparator());
		if (googleAuth) arr.push(this.renderGoogleAuth(googleAuth));

		return arr;
	}

	renderAuthSeparator() {
		return (
			<Typography className={this.props.classes.content} id="localOAuthSeparator" key="localOAuthSeparator">{translate("OR")}</Typography>
		)
	}

	renderFooter() {
		return (
			<div id="loginFooterDiv" className={this.props.classes.footer} >

				<Typography variant="caption">
					{translate("No account yet ?")}
				</Typography>

				<Typography color="primary" gutterBottom >
					<Link id="linkToSignUp" className={this.props.classes.link} to={this.state._pathname + "?signup=0"}>{translate("Create an account")}</Link>
				</Typography>


			</div>
		)
	}

	handleChange(event) {
		const { name, value } = event.currentTarget;
		this.setState({ [name]: value });
	}

	renderContent() {
		return (
			<React.Fragment >
				{this.renderAppLogo()}
				<Typography variant="h6">{this.title}</Typography>
				{this.renderListOfAuths()}
			</React.Fragment>
		);
	}

	/**
	* A local authentication
	*
	*/
	renderLocalAuth() {
		return (

			<form key="localAuth" className={this.props.classes.form} onSubmit={(e) => {
				if (e) e.preventDefault();
				this.login(e);
			}}>
				<FormControl margin="normal" required fullWidth>
					<InputLabel htmlFor="email">{translate("Username")}</InputLabel>
					<Input
						id="email"
						name="login"
						onChange={this.handleChange}
						autoComplete="email"
						defaultValue={this.state.login}
						autoFocus={this.state.login === undefined}
					/>
				</FormControl>
				<FormControl margin="normal" required fullWidth>
					<InputLabel htmlFor="password">{translate("Password")}</InputLabel>
					<Input
						name="password"
						type="password"
						onChange={this.handleChange}
						id="password"
						autoComplete="current-password"
						autoFocus={this.state.login !== undefined}
					/>
				</FormControl>
				<Typography color="primary" align="right" id="linkToLostPassword">
					<Link className={this.props.classes.link} to={this.state._pathname + "?passlost=0"}>{translate("I forget my password")}</Link>
				</Typography>

				<Button
					id="loginButton"
					type="submit"
					fullWidth
					variant="contained"
					color="primary"
					className={this.props.classes.submit}
				>
					{translate("Login")}
				</Button>
			</form>
		);
	}
	renderLdapAuth() {
		return (

			<form key="ldapAuth" className={this.props.classes.form} onSubmit={(e) => {
				if (e) e.preventDefault();
				this.loginLdap(e);
			}}>
				<FormControl margin="normal" required fullWidth>
					<InputLabel htmlFor="email">{translate("Username")}</InputLabel>
					<Input
						id="email"
						name="login"
						onChange={this.handleChange}
						autoComplete="email"
						defaultValue={this.state.login}
						autoFocus={this.state.login === undefined}
					/>
				</FormControl>
				<FormControl margin="normal" required fullWidth>
					<InputLabel htmlFor="password">{translate("Password")}</InputLabel>
					<Input
						name="password"
						type="password"
						onChange={this.handleChange}
						id="password"
						autoComplete="current-password"
						autoFocus={this.state.login !== undefined}
					/>
				</FormControl>

				<Button
					id="loginButton"
					type="submit"
					fullWidth
					variant="contained"
					color="primary"
					className={this.props.classes.submit}
				>
					{translate("Login LDAP")}
				</Button>
			</form>
		);
	}
	/**
	* A local authentication
	*
	*/
	renderGoogleAuth(auth) {
		return (
			<Button
				variant="contained"
				color="secondary"
				id="gauth"
				key="LoginForm_googleAuth"
				onClick={() => {
					window.location.assign(auth.google.url);
				}
				}

			>
				{translate("Auth with Google")}
			</Button>
		)
	}

}

LoginForm.propTypes = {
	key : PropTypes.string,
	_id: PropTypes.string,
	login: PropTypes.string,
	pathName: PropTypes.string,
	global : GLOBALPROPS,
  };

export default withStyles(styles)(LoginForm)